import { ChangeDetectorRef, Component, ElementRef, NgZone, ViewChild } from '@angular/core';
import { ModalPricingDetailsComponent, ProductDetails, ThreeDProducts, ThreeDSubscriptions } from '../modal-pricing-details/modal-pricing-details.component';
import { ModalPricingService } from 'src/app/services/modal-pricing.service';
import { UserService } from 'src/app/services/user.service';
import { StripeService } from 'src/app/services/stripe.service';
import { CardService } from 'src/app/services/card.service';
import { ModalViewPricingDetailsService } from 'src/app/services/modal-view-pricing-details.service';
import { Card } from 'src/app/models/card.model';
import { PricingService } from 'src/app/services/pricing.service';
import { Rate } from 'src/app/models/rate.model';
import Swal from 'sweetalert2';
import { Roles } from 'src/app/layouts/full/shared/Enums';
import { environment } from 'src/environments/environment';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { lastValueFrom } from 'rxjs';

export type Price = {
  distributor: string,
  client: string
}

export type SubscriptionPlan = {
  title: string,
  description: string,
  price: Price
  rangedPrice: boolean
  product?: ProductDetails
}

@Component({
  selector: 'app-modal-pricing',
  standalone: true,
  imports: [SharedModule, ModalPricingDetailsComponent],
  templateUrl: './modal-pricing.component.html',
  styleUrl: './modal-pricing.component.scss'
})
export class ModalPricingComponent {
  constructor(
    public modalPricingService: ModalPricingService,
    private pricingService: PricingService,
    public userService: UserService,
    private ngZone: NgZone,
    private stripeService: StripeService,
    private cardService: CardService,
    private cd: ChangeDetectorRef,
    public modalViewPricingDetailsService: ModalViewPricingDetailsService
  ) { }

  @ViewChild('cardInfo') cardInfo: ElementRef;
  cardError: string;
  card: any;
  cards: Card[] = [];
  hideCardPayment: boolean = false;
  productSelected: Rate = null;
  prices: Rate[] = [];
  loadingPayment: boolean = false;
  selectedProductToViewDetails: ProductDetails
  elements: any[] = []

  subscriptionPlans: SubscriptionPlan[] = [
    {
      title: '3D Basic',
      description: 'Plantar Surface, Foam box',
      price: {
        client: "0,7 to 2 USD",
        distributor: "0,7 to 2 USD"
      },
      rangedPrice: true,
      product: ThreeDSubscriptions.basic
    },
    {
      title: '3D Advanced',
      description: 'Foot, Leg, Knee, Face',
      price: {
        client: "1,6 to 4 USD",
        distributor: "1,6 to 4 USD"
      },
      rangedPrice: true,
      product: ThreeDSubscriptions.advanced
    },
    {
      title: '3D Pro',
      description: 'Torso, Head',
      price: {
        client: "3,5 to 8 USD",
        distributor: "3,5 to 8 USD"
      },
      rangedPrice: true,
      product: ThreeDSubscriptions.pro
    },
    {
      title: '3D Design insoles',
      description: 'Parametric design for insoles',
      price: {
        client: "1,8 to 9 USD",
        distributor: "1,8 to 9 USD"
      },
      rangedPrice: true,
      product: ThreeDProducts.insoles
    },
    {
      title: '3D Print Insoles',
      description: 'Order 3D printed shells',
      price: {
        client: "65 USD/pair",
        distributor: "45 USD/pair"
      },
      rangedPrice: false
    },
    {
      title: '3D Design Afo',
      description: 'AFO Designs',
      price: {
        client: "12,5 to 25 USD",
        distributor: "12,5 to 25 USD"
      },
      rangedPrice: true,
      product: ThreeDProducts.afo
    },
    {
      title: '3D Design Spinal Brace',
      description: 'Spinal Brace Designs',
      price: {
        client: "40 to 80 USD",
        distributor: "40 to 80 USD"
      },
      rangedPrice: true,
      product: ThreeDProducts.spinalBrace
    }
  ]

  ngOnInit(): void {
    // this.loadStripe()
    // this.getPricing()
    this.getCards()
  }

  loadStripe() {

    if (!window.document.getElementById('stripe-custom-form-script')) {
      var s = window.document.createElement("script");
      s.id = "stripe-custom-form-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v3/";
      s.onload = () => {
        window['Stripe'].setPublishableKey('pk_test_51HziAnIZ8EP0ljSsLU8NqdawzwCaKJd3Iv4sNruShbp0xbKltFvIrqOukBzX5CQjATWrCmDU4Ns5w7Zm4arONNDZ00gQKL0Ozq');
      }

      window.document.body.appendChild(s);
    }
  }

  ngAfterViewInit(): void {
    this.hideCardPayment = true;
    this.cd.detectChanges();
  }

  mountCard(): void {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.onChange.bind(this))
  }

  showCreateCard() {
    this.hideCardPayment = false;
  }


  onChange({ error }) {
    if (error) {
      this.ngZone.run(() => this.cardError = error.message);
    } else {
      this.ngZone.run(() => this.cardError = null);
    }
  }

  getCards() {
    this.cardService.list().subscribe((cards) => {
      this.cards = cards
    })
  }

  async createCard() {
    const { token, error } = await stripe.createToken(this.card);

    if (token) {
      await this.cardService.create(token.id).subscribe((card) => {
        Swal.fire('Success', 'Card created', 'success');
        this.hideCardPayment = false;
        this.hideModal();
        this.cards.push(card);
      });
    } else {
      this.ngZone.run(() => this.cardError = error.message);
    }
  }

  async createSubscription() {
    try {
      const { token, error } = await stripe.createToken(this.card);
      if (!token) {
        this.ngZone.run(() => this.cardError = error.message);
        return;
      }

      const subscription = this.userService.user.role === Roles.ROLE_DISTRIBUTOR
        ? environment.stripeSubscriptions.distributor.old
        : environment.stripeSubscriptions.client.old;

      Swal.fire({
        title: 'Subscription in progress ...',
        text: 'Wait until we check your card and subscription',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      // ✅ Convertimos la suscripción en una Promise para usar `await`
      await lastValueFrom(this.stripeService.subscribe(subscription, token.id));

      this.modalPricingService.userSubscriber.emit('user_subscribed');
      this.hideModal();
      Swal.fire('成功', '订阅已创建！', 'success');

    } catch (error) {
      Swal.fire('Error', error?.error?.message || 'Subscription failed', 'error');
    }
  }


  changePlan() {
    this.productSelected = null;
    this.hideCardPayment = true;
  }

  showCardInput() {
    if (!this.card) {
      this.mountCard();
    }

    this.hideCardPayment = false;
  }

  hideModal(): void {
    if (this.card) {
      this.card.destroy();
    }

    this.card = null;
    this.changePlan();
    this.modalPricingService.hideModal();
  }

  getPricing() {
    this.pricingService.getRates().subscribe((prices) => {
      this.prices = prices
    })
  }

  showPricingDetails(product: ProductDetails) {
    this.selectedProductToViewDetails = product
    this.modalViewPricingDetailsService.showModal();
  }

}
